export default {
  api_r_user_chatbot_getAvailableBots: {
    path: 'chatbot/get-available-bots/',
  },
  api_r_user_chatbot_chat: {
    path: 'chatbot/chat/',
  },
};
